export default "__VITE_ASSET__BoAdZWrU__";